import { render, staticRenderFns } from "./TradeAttachments.vue?vue&type=template&id=5740a405&"
import script from "./TradeAttachments.vue?vue&type=script&lang=js&"
export * from "./TradeAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TradeAttachments.vue?vue&type=style&index=0&id=5740a405&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports